import React from "react";

const Rightcontainer = () => {
  return (
    <div className="rightContainer">
      <div className="rcBanner">
        {/* Live Status Pill */}
        <div className="rcLivePill">
          <span className="rcLiveDot"></span>
          <span>10,000+ Real Players Online</span>
        </div>

        <picture className="rcBanner-img-container">
          <img src="/logo.png" alt="logo" className="img-fluid" />
        </picture>

        <div className="rcBanner-text">
          <span className="rcBanner-text-bold">
            Play, Win &amp; Withdraw Instantly!
          </span>
          <p className="rcBanner-subtitle">
            Battle Real Opponents in 1v1 Ludo Classic &amp; Win Real Cash with Instant UPI Payouts.
          </p>
        </div>

        <div className="rcBanner-features">
          <div className="rcFeature-item">
            <div className="rcFeature-icon-wrap">
              <img src="/images/icons/win-cash.png" alt="Win" className="rcFeature-icon" />
            </div>
            <div className="rcFeature-meta">
              <strong>Instant Payouts</strong>
              <small>30-Sec direct UPI/Bank</small>
            </div>
          </div>

          <div className="rcFeature-item">
            <div className="rcFeature-icon-wrap">
              <img src="/images/insurance.png" alt="Secure" className="rcFeature-icon" />
            </div>
            <div className="rcFeature-meta">
              <strong>100% Safe &amp; Fair</strong>
              <small>RNG Certified &amp; Zero Bots</small>
            </div>
          </div>

          <div className="rcFeature-item">
            <div className="rcFeature-icon-wrap">
              <img src="/images/technical-support.png" alt="Support" className="rcFeature-icon" />
            </div>
            <div className="rcFeature-meta">
              <strong>24x7 Customer Help</strong>
              <small>WhatsApp &amp; Live Chat</small>
            </div>
          </div>
        </div>

        <div className="rcBanner-footer">
          <span>For best mobile experience, open&nbsp;</span>
          <a href="/" rel="noreferrer">
            https://kingmastar
          </a>
          <span>&nbsp;on&nbsp;</span>
          <img src={process.env.PUBLIC_URL + "/images/chrome.png"} alt="Chrome" />
          <span>&nbsp;Chrome Mobile</span>
        </div>
      </div>
    </div>
  );
};

export default Rightcontainer;
